<template>
  <div class="invisible-scrollbar">
    <v-card style="display: contents">
      <div class="blacklist-page">
        <div
          class="pt-8"
          style="
            font-size: 20px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
          "
        >
          {{ $t("message.BlackList") }}
        </div>
        <v-card-text>
          <div>
            <v-card elevation="10" class="blacklist-filter-card">
              <v-row align="center">
                <v-col cols="12" sm="6" md="4" lg="4" class="blacklist-search-col" style="margin-top: 25px;">
                  <v-text-field
                    :label="$t('message.Search')"
                    append-icon="mdi-database-search-outline"
                    v-model="search"
                    v-on:keyup.enter="SearchDataRoleList(search)"
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="5" lg="4" class="pt-3 blacklist-filter-actions">
                  <v-btn
                    color="primary"
                    class="ma-2 white--text"
                    @click="getDataBlackListVisitor()"
                    >{{ $t("message.Search") }}
                    <v-icon right>mdi-magnify</v-icon>
                  </v-btn>
                  <v-btn
                    color="green"
                    class="ma-2 white--text"
                    @click="openBlacklistDialog('create', null)"
                    >{{ $t("message.Create") }}
                    <v-icon right>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </div>
          <div>
            <v-card elevation="10" class="blacklist-list-card">
              <v-card elevation="6" class="blacklist-table-card">
                <div class="table-responsive">
                  <v-data-table
                    class="blacklist-table"
                    :headers="headers"
                    :items="ListData"
                    hide-default-footer
                    :items-per-page="itemsPerPage"
                    :page.sync="page"
                    :mobile-breakpoint="0"
                    single-line
                    hide-details
                  >
                    <template
                      v-if="!$vuetify.breakpoint.smAndDown"
                      v-slot:item="{ item, index }"
                    >
                      <tr>
                        <td class="header-table-css">
                          {{ no_run + (index + 1) }}
                        </td>
                        <td class="header-table-css">{{ item.visitorName }}</td>
                        <td class="header-table-css">
                          {{ item.visitorLastName }}
                        </td>
                        <td class="header-table-css">
                          {{ ChangeFormatDate(item.createTime) }}
                        </td>
                        <td class="text-center">
                          <v-btn
                            :color="GetColor(item.active)"
                            rounded
                            class="text-capitalize"
                            depressed
                            style="width: 120px"
                          >
                            <span :style="{ color: GetColorText(item.active) }">
                              {{
                                item.active
                                  ? $t("message.Active")
                                  : $t("message.InActive")
                              }}
                            </span>
                          </v-btn>
                        </td>
                        <td class="text-center">
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            small
                            color="orange"
                            @click="openBlacklistDialog('edit', item)"
                          >
                            <v-icon dark>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            small
                            color="red"
                            @click="InActiveDataBlacklistVisitor(item)"
                          >
                            <v-icon dark>mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                    <template v-else v-slot:item="{ item, index }">
                      <tr>
                        <td class="header-table-css">
                          {{ no_run + (index + 1) }}
                        </td>
                        <td class="header-table-css">
                          {{ item.visitorName }}
                        </td>
                        <td class="text-center">
                          <v-btn
                            :color="GetColor(item.active)"
                            rounded
                            class="text-capitalize"
                            depressed
                            style="width: 100px"
                          >
                            <span :style="{ color: GetColorText(item.active) }">
                              {{ item.active ? "Active" : "InActive" }}
                            </span>
                          </v-btn>
                        </td>
                        <td class="text-center">
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            small
                            color="orange"
                            @click="openBlacklistDialog('edit', item)"
                          >
                            <v-icon dark>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            small
                            color="red"
                            @click="InActiveDataBlacklistVisitor(item)"
                          >
                            <v-icon dark>mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
              </v-card>

              <v-row class="mt-5 blacklist-pagination-row" align="center">
                <v-col cols="12" md="8" lg="9" class="blacklist-pagination-col">
                  <v-pagination
                    v-model="page"
                    :total-visible="paginationTotalVisible"
                    :length="pageCount"
                    @input="ChangePage(page)"
                  ></v-pagination>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="blacklist-page-size-col">
                  <v-autocomplete
                    class="blacklist-page-size"
                    dense
                    solo
                    v-model="itemsPerPage"
                    @input="ChangePerPage(itemsPerPage)"
                    :items="items"
                    label="10/page"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog
      v-model="BlacklistVisitorDialog"
      persistent
      max-width="900px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card class="rounded-xl elevation-4 blacklist-dialog-card">
        <v-card-title
          class="d-flex align-center justify-space-between py-4 bg-primary text-white rounded-t-xl"
        >
          <span class="text-h6 font-weight-bold">{{
            $t("message.BlackList")
          }}</span>
          <v-btn icon @click="closeBlackListVisitorDialog()" class="text-white">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-6 blacklist-dialog-content">
          <v-row dense>
            <v-col cols="12" md="2" v-if="EditStatus">
              <v-text-field
                :label="$t('message.BlacklistID')"
                v-model="BlacklistID"
                outlined
                dense
                disabled
              />
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                :label="$t('message.FirstName')"
                v-model="VisitorName"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                :label="$t('message.LastName')"
                v-model="VisitorLastName"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="8">
              <v-textarea
                :label="$t('message.Remark')"
                v-model="Remark"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <div class="blacklist-status-row">
            <v-radio-group row v-model="Active">
              <v-radio
                :label="$t('message.Active')"
                value="1"
                color="success"
              ></v-radio>
              <v-radio
                :label="$t('message.InActive')"
                value="2"
                color="error"
              ></v-radio>
            </v-radio-group>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="blacklist-dialog-actions">
          <v-btn
            v-if="EditStatus"
            color="success"
            class="white--text text-capitalize"
            width="120"
            :block="$vuetify.breakpoint.xsOnly"
            @click="ManageDataBlackListVisitor()"
          >
            {{ $t("message.Update") }}
          </v-btn>
          <v-btn
            v-else
            color="success"
            class="white--text text-capitalize"
            width="120"
            :block="$vuetify.breakpoint.xsOnly"
            @click="ManageDataBlackListVisitor()"
          >
            {{ $t("message.Create") }}
          </v-btn>

          <v-btn
            color="error"
            class="ml-2 white--text text-capitalize"
            width="120"
            :block="$vuetify.breakpoint.xsOnly"
            @click="closeBlackListVisitorDialog()"
          >
            {{ $t("message.Cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "BlacklistVisitor",
  components: {},
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      items: [10, 15, 20, 50, 100],
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      search: "",
      no_run: 0,
      ListData: [],
      RoleDetailDialog: false,
      EditStatus: false,
      RoleID: 0,
      RoleName: "",

      RedemptionStatus: false,
      MyQRStatus: false,
      PreRegisterStatus: false,
      CallLiftStatus: false,
      ManageUserStatus: false,

      PreRegisterCarpark: false,
      WalkIn: false,
      ManagePreRegisterCarpark: false,
      ManageRole: false,
      ManageApprover: false,

      BlacklistVisitorDialog: false,
      BlacklistID: null,
      VisitorName: "",
      VisitorLastName: "",
      Remark: "",
      Active: null,
    };
  },
  computed: {
    headers() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return [
          {
            text: this.$t("message.No"),
            sortable: false,
            align: "left",
          },
          {
            text: this.$t("message.FirstName"),
            align: "left",
            sortable: false,
          },
          {
            text: this.$t("message.Status"),
            align: "center",
            sortable: false,
          },
          {
            text: this.$t("message.Action"),
            align: "center",
            sortable: false,
          },
        ];
      }

      return [
        {
          text: this.$t("message.No"),
          sortable: false,
          align: "left",
        },
        {
          text: this.$t("message.FirstName"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.LastName"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.CreateTime"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.Status"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("message.Action"),
          align: "center",
          sortable: false,
        },
      ];
    },
    paginationTotalVisible() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 5;
      }

      if (this.$vuetify.breakpoint.smAndDown) {
        return 7;
      }

      return 10;
    },
  },

  async mounted() {
    let self = this;
    await self.getDataBlackListVisitor();
  },

  methods: {
    getDataBlackListVisitor() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: self.page,
        perPage: self.itemsPerPage,
      };
      axios
        .post(`${self.url}Management/getDataBlackListVisitor`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(function () {
          self.LoadingDialog = false;
        });
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: value,
        perPage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
      };
      axios
        .post(`${self.url}Management/getDataBlackListVisitor`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(function () {
          self.LoadingDialog = false;
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: 1,
        perPage: value,
      };
      axios
        .post(`${self.url}Management/getDataBlackListVisitor`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(function () {
          self.LoadingDialog = false;
        });
    },

    SearchDataRoleList(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: value,
        page: 1,
        perPage: self.itemsPerPage,
      };
      axios
        .post(`${self.url}Management/getDataBlackListVisitor`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(function () {
          self.LoadingDialog = false;
        });
    },

    closeBlackListVisitorDialog() {
      let self = this;
      self.EditStatus = false;
      self.BlacklistID = null;
      self.VisitorName = "";
      self.VisitorLastName = "";
      self.Remark = "";
      self.Active = null;
      self.BlacklistVisitorDialog = false;
    },

    getDataBlacklistVisitorByID(data) {
      let self = this;
      if (data.id != 0) {
        self.LoadingDialog = true;
        let temp = {
          blacklistID: data.id,
        };
        axios
          .post(`${self.url}Management/getDataBlacklistVisitorByID`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.BindingData(response.data.data);
            }
          })
          .catch(function (error) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 500,
              text: error.response.data.message,
            });
          })
          .finally(function () {
            self.LoadingDialog = false;
          });
      }
    },

    openBlacklistDialog(mode, data) {
      let self = this;
      if (mode == "create") {
        self.BlacklistID = null;
        self.VisitorName = "";
        self.VisitorLastName = "";
        self.Remark = "";
        self.Active = null;
        self.BlacklistVisitorDialog = true;
      } else {
        self.getDataBlacklistVisitorByID(data);
      }
    },

    BindingData(data) {
      let self = this;
      self.EditStatus = true;
      self.BlacklistID = data.id;
      self.VisitorName = data.visitorName;
      self.VisitorLastName = data.visitorLastname;
      self.Remark = data.remark;
      self.Active =
        data.active == true ? "1" : data.active == false ? "2" : null;
      self.BlacklistVisitorDialog = true;
    },

    ManageDataBlackListVisitor() {
      let self = this;
      if (self.VisitorName == "" || self.visitorLastname == "" || self.Active == null) {
        Swal.fire({
          icon: "warning",
          width: 600,
          text: "กรุณากรอกข้อมูลให้ครบถ้วน !",
        });
      } else {
        if (self.EditStatus == true) {
          let temp = {
            blacklistID: self.BlacklistID,
            visitorName: self.VisitorName,
            visitorLastName: self.VisitorLastName,
            remark: self.Remark,
            active:
              self.Active == "1" ? true : self.Active == "2" ? false : null,
          };
          self.LoadingDialog = true;
          axios
            .post(`${self.url}Management/updateDataBlackList`, temp)
            .then(function (response) {
              if (response.data.status == 0) {
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.closeBlackListVisitorDialog();
                self.getDataBlackListVisitor();
              }
            })
            .catch(function (error) {
              Swal.fire({
                icon: "error",
                title: "Error...",
                width: 500,
                text: error.response.data.message,
              });
            })
            .finally(function () {
              self.LoadingDialog = false;
            });
        } else {
          let temp = {
            visitorName: self.VisitorName,
            visitorLastName: self.VisitorLastName,
            remark: self.Remark,
            active:
              self.Active == "1" ? true : self.Active == "2" ? false : null,
          };
          self.LoadingDialog = true;
          axios
            .post(`${self.url}Management/addDataBlackList`, temp)
            .then(function (response) {
              if (response.data.status == 0) {
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.page = 1;
                self.closeBlackListVisitorDialog();
                self.getDataBlackListVisitor();
              }
            })
            .catch(function (error) {
              Swal.fire({
                icon: "error",
                title: "Error...",
                width: 500,
                text: error.response.data.message,
              });
            })
            .finally(function () {
              self.LoadingDialog = false;
            });
        }
      }
    },

    InActiveDataBlacklistVisitor(data) {
      let self = this;
      let temp = {
        blacklistID: data.id,
      };
      Swal.fire({
        text: "คุณต้องการ In Active ข้อมูลนี้ใช่หรือไม่ ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "green",
        cancelButtonColor: "#d33",
        confirmButtonText: "Submit",
      }).then((result) => {
        if (result.isConfirmed) {
          self.LoadingDialog = true;
          axios
            .post(`${self.url}Management/InActiveDataBlacklistVisitor`, temp)
            .then(function (response) {
              if (response.data.status == 0) {
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.getDataBlackListVisitor();
              }
            })
            .catch(function (error) {
              self.LoadingDialog = false;
              Swal.fire({
                icon: "error",
                title: "Error...",
                width: 900,
                text: error.response.data.message,
              });
            })
            .finally(function () {
              self.LoadingDialog = false;
            });
        }
      });
    },

    GetColor(value) {
      if (value == true) {
        return "rgb(92, 184, 92,0.3)";
      } else {
        return "rgb(232, 34, 34,0.3)";
      }
    },

    GetColorText(value) {
      if (value == true) {
        return "rgb(92, 184, 92)";
      } else {
        return "rgb(232, 34, 34)";
      }
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },
  },
};
</script>
  <style scoped>
* >>> .v-data-table-header {
  background-color: black;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}

.table-responsive {
  width: 100%;
  overflow-x: auto;
}

.blacklist-page {
  margin-left: 10px;
  margin-right: 10px;
}

.blacklist-filter-card,
.blacklist-list-card {
  padding: 2%;
  margin-top: 2%;
  margin-bottom: 2%;
}

.blacklist-filter-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.blacklist-table-card {
  padding: 16px;
  margin-bottom: 16px;
}

.blacklist-table {
  min-width: 760px;
  color: #332f2fde;
}

.blacklist-pagination-col {
  display: flex;
  justify-content: center;
}

.blacklist-page-size-col {
  display: flex;
  justify-content: flex-end;
}

.blacklist-page-size {
  max-width: 180px;
}

.blacklist-status-row {
  display: flex;
  justify-content: flex-end;
}

.blacklist-dialog-card {
  overflow: hidden;
}

.blacklist-dialog-actions {
  display: flex;
  justify-content: flex-end;
  padding: 16px;
}

@media (max-width: 959px) {
  .blacklist-table {
    min-width: 560px;
  }

  .blacklist-page-size-col {
    justify-content: center;
  }

  .blacklist-page-size {
    max-width: 220px;
  }
}

@media (max-width: 599px) {
  .blacklist-page {
    margin-left: 0;
    margin-right: 0;
  }

  .blacklist-filter-card,
  .blacklist-list-card {
    padding: 12px;
    margin-top: 12px;
    margin-bottom: 12px;
  }

  .blacklist-filter-actions {
    display: block;
    padding-top: 0 !important;
  }

  .blacklist-table-card {
    padding: 8px;
  }

  .blacklist-table {
    min-width: 520px;
  }

  .blacklist-dialog-card {
    border-radius: 0 !important;
  }

  .blacklist-dialog-content {
    padding: 16px !important;
  }

  .blacklist-status-row {
    justify-content: flex-start;
  }

  .blacklist-dialog-actions {
    display: block;
    padding: 16px;
  }

  .blacklist-dialog-actions .v-btn {
    margin-left: 0 !important;
    margin-top: 8px;
  }
}
</style>
  
